import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes default (overridden for messages)
      gcTime: 10 * 60 * 1000, // 10 minutes garbage collection time
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 404) return false
        return failureCount < 3
      },
      refetchOnWindowFocus: true, // Refetch when window regains focus
      refetchOnMount: true, // Refetch when component mounts
      refetchOnReconnect: true, // Refetch on network reconnect
    },
    mutations: {
      retry: false,
    },
  },
})
